'use strict';
import React from 'react';
import PageHeaderNavigation from './pageHeaderNavigation';
import _ from 'lodash';
/**
 * Defines a page title, optional page level buttons, and subhead.
 *
 * @extends {React.Component}
 * @property {String} title Page header title.
 * @property {String} subhead Optional subhead.
 */
class PageHeader extends React.Component {

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    const { children, subhead, title } = this.props,
          pageHeaderNavigation = _.find(React.Children.toArray(children), {type: PageHeaderNavigation})

    return (
      <div className="PageHeader">
        { pageHeaderNavigation }
        <h2 className="PageHeader-title">{ title }</h2>
        <div className="PageHeader-subhead">{ subhead }</div>
      </div>
    );
  }
}

/**
 * @prop {propTypes} propTypes - required attributes for the PageHeader component
 */
PageHeader.propTypes = {
  title: React.PropTypes.string.isRequired
};

export default PageHeader;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/pageHeader/pageHeader.jsx